import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Mission() {
  return (
    <section className="mission-con position-relative">
      <div className="container">
        <div className="row">

          <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-1 order-2">
            <div className="mission_content position-relative">

              <motion.h2
                className="text-white"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                Our Journey
              </motion.h2>

              <motion.p
                className="text-white"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
                viewport={{ once: true }}
              >
                It began with a simple dream to make the best ice cream using only the finest ingredients, crafted meticulously in-house
              </motion.p>

              <motion.h2
                className="text-white"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: true }}
              >
                Our MiSSion
              </motion.h2>

              <motion.p
                className="text-white"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.5 }}
                viewport={{ once: true }}
              >
                It began with a simple dream to make the best ice cream using only the finest ingredients, crafted meticulously in-house
              </motion.p>

              <figure className="mission-triangle mb-0">
                <img
                  src="/assets/images/element_21.png"
                  alt="image"
                  className="img-fluid element"
                />
              </figure>


            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-2 order-1">
            <motion.div
              className="mission_wrapper"
              initial={{ opacity: 0, x: 80, scale: 0.9 }}
              whileInView={{ opacity: 1, x: 0, scale: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true, amount: 0.4 }}
            >
              <motion.figure
                className="mission-image mb-0"
                animate={{ y: [0, -12, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              >
                <motion.img
                  src="/assets/images/mission-image.jpg"
                  alt="image"
                  className="img-fluid"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                />
              </motion.figure>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Mission;